import React, { useState } from "react";
import { injectIntl, intlShape } from "react-intl";
import PropTypes from "prop-types";
import copyTokens from "@amzn/meridian-tokens/base/icon/copy";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import Alert from "@amzn/meridian/alert";
import Toaster from "@amzn/meridian/toaster";

export const CopyButton = ({ intl, textToCopy, size = "small", circular = true }) => {
  const [toasts, setToasts] = useState([]);
  
  const onCloseToast = (id) => {
    setToasts(toasts.filter(t => t.id !== id));
  };
  
  const onOpenToast = () => {
    setToasts(toasts.concat({ id: `copyToast-${Date.now()}`, timeout: 1000 }));
  };
  
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      onOpenToast();
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const copiedMessage = intl.formatMessage({
    id: "common.copyButton.success",
    defaultMessage: "Copied",
  });

  const ariaLabel = intl.formatMessage({
    id: "common.copyButton.label",
    defaultMessage: "Copy to clipboard",
  });

  return (
    <React.Fragment>
      <Toaster
        toasts={toasts}
        onCloseToast={onCloseToast}
        alignmentHorizontal="end"
      >
        {toast => (
          <Alert type="success" toast={true} onClose={toast.onClose}>
            {copiedMessage}
          </Alert>
        )}
      </Toaster>
      <Button
        circular={circular}
        type="icon"
        size={size}
        onClick={handleCopy}
        aria-label={ariaLabel}
      >
        <Icon tokens={copyTokens} />
      </Button>
    </React.Fragment>
  );
};

CopyButton.propTypes = {
  intl: intlShape.isRequired,
  textToCopy: PropTypes.string.isRequired,
  size: PropTypes.string,
  circular: PropTypes.bool,
};

export default injectIntl(CopyButton);



// WEBPACK FOOTER //
// ./src/components/common/CopyButton.jsx